import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { connectWhatsApp } from '@/services/whatsapp.service';
import { sanitizeSupabaseError } from '@/lib/errorHandler';

export function useConnectWhatsApp() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: connectWhatsApp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['whatsapp-channel'] });
      toast.success(t('settings.whatsapp.connectedToast'));
    },
    onError: (err) => {
      toast.error(sanitizeSupabaseError(err));
    },
  });
}
